

<template>
    <div class="main-body">
        <!-- 2022.03.17 暂时只展示评论好礼功能，需iOS壳包配置对应跳转许可，后续新游戏中增加 -->
        <div class="main-review" v-show="isShowReview">
            <img
                class="icon-review"
                :src="gift_logo"
                @click="onClickReview"
            />
        </div>
        <div class="no-cell" v-if="isCycleElement" />
        <h5-dialog
            closeable
            mode="full"
            @on-close="onCloseGift"
            v-show="!!praise_logo && showPop"
            style="z-index:1007;"
        >
            <img
                class="center-img"
                :src="praise_logo"
                @click="toAppStore"
            />
        </h5-dialog>

        <h5-dialog
            closeable
            mode="full"
            @on-close="onClose"
            v-show="!!add_group_logo && showAddGroup"
            style="z-index:1007;"
        >
            <img
                class="center-img"
                :src="add_group_logo"
                @click="handleJoinQQGroup"
            />
        </h5-dialog>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { Dialog } from 'vant'
import H5Dialog from './H5Dialog.vue'

const giftIcon = 'http://statictest.3698k.com/picture/20220324/ac310c62231651c42c81711ef1265173.jpg' // 背景图（无立即领取按钮）
const addQQ = 'http://statictest.3698k.com/picture/20220401/172508435556bcfb82e207ee50f3758e.png'

const reviewIcon = 'http://statictest.3698k.com/picture/20220331/30e101dd47047e48fb5fe68630644100.gif' // 评论好礼小图标（gif动图）

// 评论好礼 自动隐藏定时器
let ReviewTimeOut = null

export default {
    name: 'WriteReview',
    components: { H5Dialog },
    props: {
        isHide: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            showPop: false,
            showAddGroup: false,
            // dynamicStyle: { width: '80%' },
            clickSum: 0,
            justShow: true,
            isCycle: true, // 是否循环渲染（2020.05.11修复iOS设备无法点击的问题）
            isCycleElement: true, // 渲染元素
        }
    },
    watch: {
        $route(pre) {
            if (pre.path === '/chargeCenter') {
                this.justShow = false
            }
        }
    },
    computed: {
        ...mapState({
            gameID: state => state?.app?.appConfig?.game_id || '',
            ...(process.env.NODE_ENV === 'production' ? {
                gift_logo: state => state?.app?.gift_logo, // 好评有礼图标
                praise_logo: state => state?.app?.praise_logo, // 好评有礼弹窗图
                add_group_logo: state => state?.app?.add_group_logo, // 加群弹窗图
            } : {
                gift_logo: () => reviewIcon, // 好评有礼图标（测试用）
                praise_logo: () => giftIcon, // 好评有礼弹窗图（测试用）
                add_group_logo: () => addQQ, // 加群弹窗图（测试用）
            })
        }),
        isShowReview() {
            const thePath = this.$route.path
            if (!this.isHide && this.justShow &&
                (this.gift_logo || this.praise_logo || this.add_group_logo) &&
                (thePath === '/login' || thePath === '/register' || thePath === '/resetPassword')
            ) {
                return true
            }
            return false
        },
        serviceData() {
            return this.$store.state.serviceInfo
        },
    },
    methods: {
        // allowByTime() {
        //     // 判断时间：每天显示一次好评有礼
        //     const nowTime = new Date()
        //     const closeTime = localStorage.getItem('TheCloseTimeOfGoodComment')
        //     const lastTime = closeTime ? new Date(closeTime).getDate() : null

        //     if (!closeTime || nowTime.getDate() !== lastTime) {
        //         localStorage.setItem('TheCloseTimeOfGoodComment', nowTime)
        //         this.justShow = true
        //         return true
        //     }

        //     this.justShow = false
        //     return false
        // },
        // 监听手机横竖屏
        // renderResize() {
        //     // 判断横竖屏
        //     let width = document.documentElement.clientWidth
        //     let height = document.documentElement.clientHeight
        //     if (width > height) {
        //         // 横屏
        //         this.dynamicStyle = { height: '80%' }
        //     } else {
        //         // 竖屏
        //         this.dynamicStyle = { width: '80%' }
        //     }
        // },
        // 好评弹窗关闭
        onCloseGift() {
            this.showPop = false
            setTimeout(() => {
                this.showAddGroup = true
            }, 400)
            this.onClose()
        },
        // 加群弹窗关闭时
        onClose() {
            this.showAddGroup = false
            if (this.clickSum >= 3) {
                this.justShow = false
            }
        },
        // 点击评论好礼图标
        onClickReview() {
            if (this.praise_logo) {
                this.showPop = !this.showPop
            } else if (this.add_group_logo) {
                this.showAddGroup = !this.showAddGroup
            }
            this.clickSum++
        },
        // 加QQ群
        handleJoinQQGroup() {
            // const groupLink = this.serviceData.qq_group_id
            // this.$dialog({
            //     title: '正在尝试跳转QQ群',
            // })

            // // 2022.05.27 iOS新壳包跳转方式（game_id: 1112004）
            // if (window?.webkit?.messageHandlers?.ios_jumpstore?.postMessage) {
            //     window.webkit.messageHandlers.ios_jumpstore.postMessage(groupLink)
            // } else {
            //     const tempFrame = document.createElement('iframe')
            //     tempFrame.setAttribute('frameborder', '0')
            //     tempFrame.setAttribute('src', groupLink)
            //     tempFrame.setAttribute('style', 'visibility: hidden;z-index: 0')
            //     tempFrame.onload = () => {
            //         console.log('JoinQQGroup Frame loaded')
            //         setTimeout(() => {
            //             document.body.removeChild(tempFrame)
            //             Dialog.close()
            //         }, 2000)
            //     }

            //     tempFrame.onerror = () => {
            //         //    打开链接失败
            //         // this.$dialog({
            //         //     title: '打开QQ异常',
            //         // })
            //     }
            //     document.body.appendChild(tempFrame)
            // }

            // // 自动关闭加群弹窗
            // setTimeout(() => {
            //     this.showAddGroup = false
            //     this.onClose()
            // }, 500)
        },
        // 以 iframe形式跳转苹果应用商店
        toAppStore() {
            try {
                // 2026.08.26 拉起安卓好评弹窗
                if (window?.JsJingYouNativeBridge?.launchGooglePlay) {
                    window?.JsJingYouNativeBridge?.launchGooglePlay?.()
                    console.log('JsJingYouNativeBridge.launchGooglePlay<Android> | launchGooglePlay >>> ')
                    return
                }
            } catch (err) {
                console.error('>>> post Android launchGooglePlay fail', err)
            }

            const appleID = this.$store?.state?.app?.channel_app_id
            if (!appleID) {
                // this.$toast('跳转应用商店失败: 无appID')
                return
            }
            const AppStoreUrl = `itms-apps://itunes.apple.com/app/id${ appleID }?action=write-review`

            // 2022.05.27 iOS新壳包跳转方式（game_id: 1112004）
            if (window?.webkit?.messageHandlers?.ios_jumpstore?.postMessage) {
                window.webkit.messageHandlers.ios_jumpstore.postMessage(AppStoreUrl)
            } else {
                // 2022.03.16 更换跳转方式
                window.location.href = AppStoreUrl
            }

            setTimeout(() => {
                // 关闭评论弹窗
                this.onCloseGift()
            }, 1000)
        },
        // 循环显示某个元素，让页面处于渲染状态，防止出现ios上无法点击的问题
        async recycleIcon() {
            if (!this.isCycle) {
                return
            }
            this.isCycleElement = false
            setTimeout(() => {
                this.isCycleElement = true
                setTimeout(() => {
                    this.recycleIcon()
                }, 3000)
            }, 600)
        }
    },
    mounted() {
        // 监听手机横竖屏
        // window.addEventListener('resize', this.renderResize, false)

        // 2022.03.23 设置定时器，30秒后自动关闭 评论好礼 图标
        ReviewTimeOut = setTimeout(() => {
            this.justShow = false
        }, 60 * 1000)

        // 2022.05.11 尝试增加定时器 修复iOS设备兼容性问题，导致自动登录后无法点击
        this.recycleIcon()
        setTimeout(() => {
            this.isCycle = false
            this.isCycleElement = false
        }, 70 * 1000)

        // this.allowByTime()
    },
    beforeDestroy () {
        // 移除监听手机横竖屏
        // window.removeEventListener('resize', this.renderResize, false)

        // 移除定时器
        clearTimeout(ReviewTimeOut)
    }
}
</script>

<style lang="scss" scoped>
.main-body {
    .main-review {
        position: fixed;
        right: 30px;
        bottom: 30px;
        width: 85px;
        height: 85px;
        background: transparent;
        z-index: 1006;

        .icon-review {
            max-height: 100%;
            max-width: 100%;
        }
    }

    .popup-review {
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: transparent;

        .gift-icon {
            max-width: 100%;
            max-height: 100%;
        }
    }

    .no-cell {
        position: fixed;
        bottom: 0;
        left: 0;
        width: 20px;
        height: 20px;
        background-color: transparent;
        opacity: 0;
    }

    .center-img {
        width: 100%;
    }
}
</style>